/** 8+1 维度编号 → 中文展示名（与后端 dimension-labels.js 对齐） */
export const DIMENSION_LABELS = {
  D1: '产品适配',
  D2a: '表现水平',
  D2b: '表现质量',
  D2c: '底层资产',
  D3: '基准归因',
  D4: '宏观匹配',
  D5: '同类相对',
  D6: '流动性',
  D7: '情景参考',
  D8: '策略稳定',
  'D+': '持仓占比',
  决策: '决策汇总'
};

export function resolveDimensionLabel(input) {
  if (!input) return '—';
  const code = String(input).trim().split(/\s+/)[0];
  return DIMENSION_LABELS[code] || String(input);
}
